import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import ButtonLink from '../ButtonLink';
import LazyImg from '../LazyImg';
import spCss from '../ShopPoster/ShopPoster.module.scss';
import css from './ShopPosterFooter.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var useInterval = function useInterval(callback, delay) {
  var savedCallback = useRef(); // Remember the latest function.

  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval.

  return useEffect(function () {
    var tick = function tick() {
      return savedCallback.current();
    };

    var id = setInterval(tick, delay);
    return function () {
      return clearInterval(id);
    };
  }, [delay]);
};

var ShopPosterFooter = function ShopPosterFooter(_ref) {
  var cta = _ref.cta,
      fabric = _ref.fabric,
      image = _ref.image,
      messages = _ref.messages;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var delay = 2000;
  useInterval(function () {
    var nextCount = count + 1;

    if (nextCount >= messages.length) {
      nextCount = 0;
    }

    setCount(nextCount);
  }, delay);
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, spCss.root]),
    children: [/*#__PURE__*/_jsx(LazyImg, _objectSpread({
      className: spCss.img
    }, image)), /*#__PURE__*/_jsxs("div", {
      className: cc([spCss.content, css.content]),
      children: [/*#__PURE__*/_jsx("p", {
        className: css.intro,
        children: "Introducing ".concat(fabric, ":")
      }), /*#__PURE__*/_jsx("span", {
        className: cc([spCss.message, css.messageStatic]),
        children: "Feels Like"
      }), /*#__PURE__*/_jsx("ul", {
        className: css.messages,
        children: messages.map(function (message, i) {
          return /*#__PURE__*/_jsx("li", {
            className: cc([_defineProperty({}, css.active, i === count), css.message, spCss.message]),
            children: message
          }, message);
        })
      }), /*#__PURE__*/_jsx("div", {
        className: cc([spCss.button, css.button]),
        children: /*#__PURE__*/_jsx(ButtonLink, _objectSpread(_objectSpread({}, cta), {}, {
          big: true,
          borderedHover: true,
          borderedInverseHover: true,
          medium: true,
          children: cta.text
        }))
      })]
    })]
  });
};

ShopPosterFooter.propTypes = {
  cta: PropTypes.shape({
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }).isRequired,
  fabric: PropTypes.string.isRequired,
  image: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired
  }).isRequired,
  messages: PropTypes.arrayOf(PropTypes.string).isRequired
};
export default ShopPosterFooter;